const user = (state) => state.user;
const userLoggedIn = (state) => state.userLoggedIn;
const newChat = (state) => state.chat;
export default {
    user,
    userLoggedIn,
    newChat
};
